{
    "Domain": "Domein:",
    "EmailServerConnectivity": "E-mailserverconnectiviteit",
    "ServerIpAddress": "Server IP adres:",
    "TcpPort": "TCP-poort:",
    "CommunicationActive": "Communicatie Actief:",
    "FromAddressEmail": "Van adres (e-mail):",
    "FromAddressName": "Van adres (naam):",
    "CompanyName": "Bedrijfsnaam:",
    "UseAuthentication": "Gebruik authenticatie:",
    "AuthenticationSettings": "Aangepaste instellingen",
    "DomainProfile_ButtonHelpLabel": "Helpen?",
    "DomainProfile_ButtonSubmitLabel": "Oke",
    "DomainProfile_ButtonCancelLabel": "Annuleren",
    "DomainProfile_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer ze worden gesloten.",
    "DomainProfile_PromptConfirm": "Ja",
    "DomainProfile_PromptCancel": "Annuleren",
    "DomainProfile_Username": "Gebruikersnaam:",
    "DomainProfile_Password": "Wachtwoord:",
    "DomainProfile_PasswordPlaceholder": "••••••",
    "NAME": "DomainProfile",
    "CustomDownloadLinks": "Aangepaste downloadlinks",
    "MSTeamsAppDownloadLinkURLName": "Download-URL voor de MS Teams-app:",
    "CXIClientDownloadLinkWindowsUrlName": "URL van CXI-client (Windows):",
    "CXIClientDownloadLinkMacUrlName": "URL van CXI-client (Mac):",
    "SearchAndCallDownloadLinkURLName": "Zoeken en bellen URL:",
    "AccessCodes": "Toegangscodes",
    "CXIAccessCode": "CXI-toegangscode:"
}